import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../lib/supabase';

interface FiscalYearConfig {
  startMonth: number;
  startDay: number;
  endMonth: number;
  endDay: number;
  loading: boolean;
}

export function useFiscalYear(): FiscalYearConfig {
  const { user } = useAuth();
  const [startMonth, setStartMonth] = useState(9);
  const [startDay, setStartDay] = useState(1);
  const [endMonth, setEndMonth] = useState(8);
  const [endDay, setEndDay] = useState(31);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadFiscalYearConfig();
  }, [user]);

  async function loadFiscalYearConfig() {
    if (!user) {
      setLoading(false);
      return;
    }

    try {
      const { data } = await supabase
        .from('user_profiles')
        .select('fiscal_year_start_month, fiscal_year_start_day, fiscal_year_end_month, fiscal_year_end_day')
        .eq('id', user.id)
        .maybeSingle();

      if (data) {
        setStartMonth(data.fiscal_year_start_month || 9);
        setStartDay(data.fiscal_year_start_day || 1);
        setEndMonth(data.fiscal_year_end_month || 8);
        setEndDay(data.fiscal_year_end_day || 31);
      }
    } catch (error) {
      console.error('Error loading fiscal year config:', error);
    } finally {
      setLoading(false);
    }
  }

  return {
    startMonth,
    startDay,
    endMonth,
    endDay,
    loading
  };
}
